import { Modal } from '@mantine/core'
import { createFileRoute, useRouter } from '@tanstack/react-router'
import ContactInfoModal from '@/components/make-booking/checkout/modals/ContactInfoModal'

export const Route = createFileRoute('/make-booking/$id/checkout/contact')({
  component: RouteComponent,
})

function RouteComponent() {
  const router = useRouter()
  return (
    <Modal
      opened
      onClose={() => router.history.back()}
      title="Edit Contact Info"
      centered
      classNames={{
        title: '!text-[22px] !font-bold',
        content: '!p-5',
      }}
      size="xl"
    >
      <ContactInfoModal onClose={() => router.history.back()} />
    </Modal>
  )
}
